import { focusEditor, useEditorRef, useHotkeys } from '@udecode/plate-common';

import {
  floatingLinkActions,
  floatingLinkSelectors,
  useFloatingLinkSelectors,
} from './floatingLinksStore';

export const useFloatingInterlinkEscape = (): void => {
  const editor = useEditorRef();

  const isOpen = useFloatingLinkSelectors().isOpen(editor.id);

  useHotkeys(
    'escape',
    (e) => {
      if (!floatingLinkSelectors.mode()) return;

      e.preventDefault();

      if (
        floatingLinkSelectors.mode() === 'edit' &&
        floatingLinkSelectors.isEditing()
      ) {
        floatingLinkActions.show('edit', editor.id);
        focusEditor(editor, editor.selection!);
        return;
      }

      if (floatingLinkSelectors.mode() === 'insert') {
        focusEditor(editor, editor.selection!);
      }

      floatingLinkActions.hide();
    },
    {
      enabled: isOpen,
      enableOnFormTags: ['INPUT'],
      enableOnContentEditable: true,
    },
    [],
  );
};
